
import Vue from 'vue';
import Component from 'vue-class-component';
import LookupMixin from './lookupMixin';
import { ResolveController } from 'rt/UIApiControllers/UI/Smart/ResolveController';

@Component({
  name: 'MailTemplateInput',
})
export default class MailTemplateInput extends LookupMixin {
  resolveController = new ResolveController(Vue.axios);

  async resolve(id: number): Promise<string> {
    return (await this.resolveController.MailTemplate(id)).name;
  }

  protected get identifier(): string {
    return 'MailTemplate';
  }
}
